import { component } from 'picoapp'
import predicativeSearch from './searchResults'


export default component((node, ctx) => {
  const cartCount = node.querySelector('.js-cart-count')
  const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')
  const mobileMenu = node.querySelector('.mobile-menu')
  const main = document.querySelector('main')

  for (let i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', e => {
      e.preventDefault()

      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
    })
  }

  predicativeSearch()

  ctx.on('cart:updated', state => {
    cartCount.innerHTML = state.cart.item_count
  })

  cartCount.innerHTML = ctx.getState().cart.item_count

  addBodyPadding()

  window.addEventListener("resize", debounce(function(e) {
    addBodyPadding()
  }))

  // get header height, offset height for fixed nav
  function addBodyPadding() {
    const height = node.offsetHeight
    // console.log('adding padding')
    main.style.paddingTop = `${height}px`
    // console.log(height)
  }

  // debounce for window resize event
  function debounce(func){
    var timer;
    return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func,100,event);
    };
  }
})
